import axios from "axios";
import setAuthToken from "../utils/setAuthToken";
import jwt_decode from "jwt-decode";
import $ from 'jquery';
import SessionDataStore from "../streaming/SessionDataStoreController";
import Util from "../streaming/Util";

import {
  GET_ERRORS,
  SET_CURRENT_USER,
  USER_LOADING
} from "./types";

// Register User
export const registerUser = (userData, history) => dispatch => {
  axios
    .post(process.env.REACT_APP_API_URL+"/api/v1/user/register", userData)
    .then(res => history.push("/login")) // re-direct to login on successful register
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Login - get user token
export const loginUser = userData => dispatch => {
  if(!navigator.onLine && window['electron'] )
  {
    dispatch({
      type: GET_ERRORS,
      payload: 'Your device is not connected to internet, please connect and retry again.'
   });
   setTimeout(()=>{$('.main_loader').hide();},1000);
   return;
  }
  
  userData['isElectron'] = 0;
  if ( window['electron'] ) { userData['isElectron'] = 1; }

  let sessionDataStore = SessionDataStore.getInstance();
  let addObject = {"sessionId": 1, "event": "status", "eventType": "login", "details": JSON.stringify({"url": process.env.REACT_APP_API_URL+"/api/v1/user/login", "userData": userData}), "timestamp": Util.getCurrentTimestamp()};
  sessionDataStore.addSessionData(addObject);
  sessionDataStore.dumpData();
 
  if ( localStorage.getItem('currentUser') && localStorage.getItem('currentUserToken') )
	{
		userData['userId'] = localStorage.getItem('currentUser');
		userData['auth'] = localStorage.getItem('currentUserToken');
		localStorage.removeItem('currentUser');
		localStorage.removeItem('currentUserToken');
	}
  
  axios
    .post(process.env.REACT_APP_API_URL+"/api/v1/user/loginNative", userData)
    .then(res => {
      console.log('res=====', res);

      // Save to localStorage
      const token  = res.data.responseData.token;

       if ($('#remember_me').is(':checked')) {
    		  localStorage.setItem("email", $('#email').val());
    		  localStorage.setItem("chkbx", $('#remember_me').val());
		  
  			  if ( window['electron'] && window['writeToFile'] )
  				{
  					window['writeToFile'](JSON.stringify({'chkbx':1, 'email':$('#email').val()}));
  				}
      } else {
          localStorage.removeItem('email');
          localStorage.removeItem('chkbx');
		 
  			  if ( window['electron'] && window['writeToFile'] )
  				{
  					window['writeToFile']('{}');
  				}
      }

      res.data.responseData.unmuteAllEnabled = false;
	  
	  let recordingAvailable = 0;
	  if ( res.data.responseData && res.data.responseData.recordingStatus )
		{
			recordingAvailable = res.data.responseData.recordingStatus;
		}
		
	  localStorage.setItem("recordingStatus", recordingAvailable);
	  
      localStorage.setItem("userData", JSON.stringify(res.data.responseData));

      // Set token to Auth header
      setAuthToken(token);

      // Decode token to get user data
      const decoded = jwt_decode(token);
      dispatch(setCurrentUser(decoded))
    })
    .catch(err => {
		$('.main_loader').hide();
		console.log('errresp - ', err.response);
		if ( err.response && err.response.data && err.response.data.errorData && err.response.data.errorData.name && err.response.data.errorData.name == 'TokenExpiredError' )
			{
				if ( window['electron'] && window['writeToFile'] ) { window['writeToFile']('{}'); }
				localStorage.removeItem('userData');
				/*dispatch({
				   type: GET_ERRORS,
				   payload: err.response !== undefined ? ((typeof err.response.data.errorData === 'string') ? err.response.data.errorData : 'We are currently experiencing issues connecting to Virdio, please try after some time') : 'We are currently experiencing issues connecting to Virdio, please try after some time'
				});*/
			}
		else
			{
				console.log('Error in login - ', err, err.response);

				dispatch({
					 type: GET_ERRORS,
					 payload: err.response !== undefined ? ((typeof err.response.data.errorData === 'string') ? err.response.data.errorData : 'We are currently experiencing issues connecting to Virdio, please try after some time') : 'We are currently experiencing issues connecting to Virdio, please try after some time'
				});
			}
      }
    );
};

// Set logged in user
export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};
// User loading
export const setUserLoading = () => {
  return {
    type: USER_LOADING
  };
};
// Log user out
export const logoutUser = () => dispatch => {

  // Remove token from local storage
 // leave();
  localStorage.removeItem("userData");
  localStorage.removeItem("sessionList");
  localStorage.removeItem("onDemandInterest");
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to empty object {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
  
};


// Log user out
export const joinConf = (channel) => dispatch => {

  var localstoragedata = JSON.parse(localStorage.getItem('userData'));

  if(localstoragedata.userType == 1){
	  //this.props.history.push("/host");
   } else {
      this.props.history.push("/guest");
   }
};

// Log user out
export const addLogs = (sessionId, userType, type) => dispatch => {
  console.log("sessionId, userType, type === ", sessionId, userType, type);
  var logData = {
    sessionId : sessionId,
    userType : userType,
    type : type
  };

  axios.post(process.env.REACT_APP_API_URL+'/api/v1/session/activity-log', logData)
  .then(function (response) {
    console.log('successfully saved')
  })
  .catch(function (error) {
    console.log(error);
  });

};